import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRouter from './AppRouter';
import { ehAppAdmin } from './utils/appAdmin';

// APK "Print Control Admin": abre só o suporte (carregado à parte, fora do app principal).
const AdminSuporteApp = React.lazy(() => import('./components/AdminSuporteApp'));

// Sem isto, qualquer erro de render desmonta o app e sobra só o fundo azul do
// body. Mostra a mensagem para o usuário conseguir relatar o que aconteceu.
class ErroGeral extends React.Component {
  state = { erro: null };
  static getDerivedStateFromError(erro) { return { erro }; }
  componentDidCatch(erro, info) { console.error(erro, info?.componentStack); }
  render() {
    if (!this.state.erro) return this.props.children;
    return <div role="alert" style={{ color: '#e8eefc', padding: 24, maxWidth: 560, margin: '15vh auto', fontFamily: 'system-ui, sans-serif' }}>
      <h1 style={{ fontSize: 22 }}>Algo deu errado nesta tela</h1>
      <p>Recarregue a página. Se continuar, envie esta mensagem ao suporte:</p>
      <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', background: '#0f1a30', padding: 12, borderRadius: 8, fontSize: 13 }}>{String(this.state.erro?.message || this.state.erro)}</pre>
      <button type="button" onClick={() => window.location.reload()} style={{ minHeight: 44, padding: '0 20px', borderRadius: 10, border: 0, background: '#19d3a2', color: '#04120d', fontWeight: 700, cursor: 'pointer' }}>Recarregar</button>
    </div>;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErroGeral>
      {ehAppAdmin()
        ? <React.Suspense fallback={null}><AdminSuporteApp /></React.Suspense>
        : <AppRouter />}
    </ErroGeral>
  </React.StrictMode>
);
